import React from "react";
import CanvasDebugger from "../../developer/CanvasDebugger/CanvasDebugger";
import PopoutWindow from "../../shared/components/PopoutWindow";

const DEV_WINDOW_FEATURES = { width: 1440, height: 900 };

type DevWindowProps = {
    setDevWindowIsClosed: () => void;
}

// The pop-out inherits the app's theme (MUI ThemeProvider + theme-mode context) from the root
// AppThemeProvider through the portal — no local theme provider is needed here. PopoutWindow supplies
// the Emotion cache bound to the pop-out's <head>, so MUI styles render in the pop-out window.
export const DevWindow: React.FC<DevWindowProps> = React.memo(({ setDevWindowIsClosed }) => (
    <PopoutWindow onUnload={setDevWindowIsClosed} url="" title="Canvas Debugger" features={DEV_WINDOW_FEATURES}>
        <CanvasDebugger />
    </PopoutWindow>
));
